import Button from './button';
export default Button;

//we have three variants default, outline, and normal, to use any of these varient you have to pass a props varient='normal' or whatever from the three varient.
